export default "__VITE_ASSET__Ca1CDFLq__"